export default __webpack_public_path__ + "static/Benefits_OzonePoolSystem_HD_411x192-9eb98242837a4580ae9f376b20a4b99e.png";